import React from 'react';
import { CarFront } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { API, withToken } from '@/utils/api';
import { CombinedMap } from '@/components/agenda/booking/CarDamageMap';
import { DAMAGE_TYPES, VIEWS, typeColor } from '@/components/agenda/booking/CarShapes';

const Item = ({ k, v, testid }) => (
  <div><p className="text-xs text-slate-500">{k}</p><p className="text-sm font-semibold" data-testid={testid}>{v || '—'}</p></div>
);
const km = (n) => (n ? `${Number(n).toLocaleString('fr-CH')} km` : '');
const when = (s) => (s || '').slice(0, 16).replace('T', ' ');

export const DamageList = ({ damages, woId }) => (
  <div className="space-y-1.5" data-testid="wo-damage-list">{damages.map((d, i) => (
    <div key={i} className="flex items-center gap-2 text-sm">
      <span className="w-5 h-5 rounded-full text-white text-[10px] font-bold flex items-center justify-center" style={{ background: typeColor(d.type) }}>{i + 1}</span>
      <span>{DAMAGE_TYPES.find(t => t.key === d.type)?.label} · {VIEWS.find(v => v.key === d.view)?.label}</span>
      {d.photo_id && woId && <a href={withToken(`${API}/work-orders/${woId}/attachments/${d.photo_id}`)} target="_blank" rel="noreferrer" className="ml-auto">
        <img src={withToken(`${API}/work-orders/${woId}/attachments/${d.photo_id}`)} alt="dégât" className="w-12 h-12 object-cover rounded border" data-testid={`wo-damage-photo-${i}`} /></a>}
    </div>))}
  </div>
);

export const CheckInSummary = ({ checkin, checkout, woId }) => {
  if (!checkin) return null;
  const damages = checkin.damages || [];
  return (
    <Card className="p-4 rounded-xl border-l-4 border-l-[#FACC15]" data-testid="wo-checkin-summary">
      <div className="flex items-center gap-2 mb-3"><CarFront className="w-4 h-4" /><h3 className="font-bold text-sm">Réception du véhicule</h3>
        <span className="ml-auto text-xs text-slate-500">{when(checkin.at)}{checkin.by ? ` · ${checkin.by}` : ''}</span></div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Item k="Kilométrage" v={km(checkin.mileage)} testid="wo-checkin-mileage" />
        <Item k="Carburant" v={checkin.fuel_level} testid="wo-checkin-fuel" />
        <Item k="Clés" v={String(checkin.keys_count ?? '')} testid="wo-checkin-keys" />
        <Item k="Signé par" v={checkin.signer_name} testid="wo-checkin-signer" />
        <div className="col-span-2"><Item k="Remarques dégâts" v={checkin.damage_notes} testid="wo-checkin-damage" /></div>
        <div className="col-span-2"><Item k="Objets laissés" v={checkin.items_left} testid="wo-checkin-items" /></div>
      </div>
      {damages.length > 0 && (
        <div className="grid md:grid-cols-2 gap-4 mt-4 items-start" data-testid="wo-damage-map">
          <div className="border rounded-lg p-1 bg-white"><CombinedMap damages={damages} /></div>
          <DamageList damages={damages} woId={woId} />
        </div>
      )}
      {checkout && (
        <div className="mt-4 pt-3 border-t" data-testid="wo-checkout-summary">
          <p className="text-sm font-bold text-emerald-700 mb-2">Restitué le {when(checkout.at)}</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <Item k="Kilométrage retour" v={km(checkout.mileage)} testid="wo-checkout-mileage" />
            <Item k="Carburant retour" v={checkout.fuel_level} testid="wo-checkout-fuel" />
            <Item k="Signé par" v={checkout.signer_name} testid="wo-checkout-signer" />
            <Item k="Remarques" v={checkout.remarks} testid="wo-checkout-remarks" />
          </div>
        </div>
      )}
    </Card>
  );
};
